import React from 'react'
import { connect } from 'kea'

import I18n from 'lib/i18n'
import BreakOnNewline from 'lib/tags/break-on-newline'

import Translate from './translate'

import courseLogic from '~/scenes/course/show/logic'

export default connect({
  props: [courseLogic, ['course']]
})(({ course: { editUrl, description, information } }) => (
  <div>
    {editUrl ? (
      <a className='button course-edit-button' href={editUrl}>
        {I18n.t('courses.show.edit_class')}
      </a>
    ) : null}

    <Translate />
    <span id='course_description'>
      <BreakOnNewline text={description} />
    </span>

    {information ? (
      <div>
        <h2>{I18n.t('courses.show.extra')}</h2>
        <Translate />
        <span id='course_information'>
          <BreakOnNewline text={information} />
        </span>
      </div>
    ) : null}
  </div>
))
